import { useParams } from 'react-router-dom';
import { ListContainer, ListContent } from '~/components/PageLayout';
import { DeviceCommandList, Layout } from './components';

export const DeviceCommands = () => {
  const params = useParams<{ deviceId: string }>();
  const deviceId = parseInt(params.deviceId ?? '');

  return (
    <Layout noPadding>
      <ListContainer>
        <ListContent>
          <DeviceCommandList deviceId={deviceId} fullHeight />
        </ListContent>
      </ListContainer>
    </Layout>
  );
};
